module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/251-samoa-9b958955adc4acd0146abd1e8ffd4116.svg";